import { ReactElement, memo } from 'react';
import { IContent } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import { Level, Section, Element } from '@zmedia/bm-soccer-ui/components';
import ContentList from '@zmedia/bm-soccer-ui/modules/content/components/list';
import styles from './style.module.scss';

interface IProps {
    items: IContent[];
    itemSizeLimit: number;
    ContentItem?: ReactElement;
    listProps?: any;
}
function HotNews({ items, listProps }: IProps) {
    if (ArrayUtils.isEmpty(items)) {
        return null;
    }

    return (
        <Section className={styles['hot-news-section']}>
            <Element renderAs="h2" />
            <Level>
                <Level.Side align="left">
                    <ContentList
                        items={items.slice(0, 2)}
                        showSapo
                        ContentItemClass={{
                            CardClass: 'flex-row md:flex-col',
                            CardHeaderClass: "md:text-[2rem]",
                            CardContentClass: "ml-[15px] md:mt-[7px] md:ml-0",
                            CardImageClass: "mt-[4px] md:mt-0 w-full",
                        }}
                        {...listProps}
                    />
                </Level.Side>
                <Level.Side align="center">
                    <ContentList
                        items={items.slice(2, 3)}
                        alignItem="vertical"
                        showSapo
                        showFullThumb
                        ContentItemClass={{
                            CardHeaderClass: "!text-[3.2rem]",
                            CardImageClass: "!w-full",
                            CardContentClass: "mt-[10px]"
                        }}
                        {...listProps}
                    />
                </Level.Side>
                <Level.Side align="right">
                    <ContentList
                        items={items.slice(3, 5)}
                        showSapo
                        ContentItemClass={{
                            CardClass: 'flex-row md:flex-col',
                            CardHeaderClass: "md:text-[2rem]",
                            CardContentClass: "ml-[15px] md:mt-[7px] md:ml-0",
                            CardImageClass: "mt-[4px] md:mt-0 w-full",
                        }}
                        {...listProps}
                    />
                </Level.Side>
            </Level>
        </Section>
    );
}

export default memo(HotNews);
